'use client';

/* eslint-disable @next/next/no-img-element -- Partner logos are small intrinsic SVG assets rendered directly in carousel slides. */
import { A11y, Autoplay, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

type PartnerLogo = {
  alt: string;
  preserveTone?: boolean;
  src: string;
};

type WarehousingLogoSwiperProps = {
  logos: readonly PartnerLogo[];
};

export function WarehousingLogoSwiper({ logos }: WarehousingLogoSwiperProps) {
  // Extra slides keep the marquee moving smoothly on wide screens.
  const carouselLogos = [
    ...logos,
    ...logos,
    ...logos,
    ...logos,
    ...logos,
    ...logos,
  ];

  return (
    <Swiper
      modules={[A11y, Autoplay, FreeMode]}
      slidesPerView="auto"
      spaceBetween={16}
      loop={carouselLogos.length > 1}
      loopAdditionalSlides={logos.length}
      loopPreventsSliding={false}
      speed={7000}
      freeMode={{ enabled: true, momentum: false }}
      allowTouchMove={false}
      autoplay={{
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        waitForTransition: true,
      }}
      className="!overflow-visible [&_.swiper-wrapper]:!ease-linear"
      breakpoints={{
        768: { spaceBetween: 20 },
      }}
      aria-label="Trusted company logos"
    >
      {carouselLogos.map((logo, index) => (
        <SwiperSlide key={`${logo.src}-${index}`} className="!w-[236px]">
          <div className="flex h-[92px] items-center justify-center rounded-[13px] bg-[#f1f2f4] px-8">
            <img
              alt={logo.alt}
              className={`max-h-[52px] max-w-full object-contain opacity-[0.58] ${
                logo.preserveTone
                  ? 'mix-blend-multiply grayscale'
                  : 'brightness-0'
              }`}
              decoding="async"
              loading={index >= logos.length ? 'lazy' : 'eager'}
              src={logo.src}
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
